import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/core/add';
import Tooltip from '@atlaskit/tooltip';
import { type SendDatabaseCreatedViewEventData } from '@databases/analytics/src/types';
import { messages } from '@databases/api-views/messages';
import React, { type FunctionComponent, useCallback } from 'react';
import { useIntl } from 'react-intl-next';

interface AddViewButtonProps {
  handleAddView: (source: SendDatabaseCreatedViewEventData['source']) => void;
}
const AddViewButton: FunctionComponent<AddViewButtonProps> = ({ handleAddView }) => {
  const { formatMessage } = useIntl();

  const handleClick = useCallback(() => {
    handleAddView('databaseViewTabs');
  }, [handleAddView]);

  return (
    <Tooltip position="bottom" content={formatMessage(messages['views.add-view-label'])}>
      <Button
        appearance="subtle"
        onClick={handleClick}
        iconBefore={<AddIcon label={formatMessage(messages['views.add-view-label'])} />}
        testId="add-view-button"
      />
    </Tooltip>
  );
};

export default AddViewButton;
